var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "ui-lightbox-close",
      class: {
        "video__pause offset white":
          _vm.$root.lightboxToggled.indexOf("lightboxVideo") > -1
      }
    },
    [_c("span", [_vm._v("Close")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }